( function () {
	const siteNavigation = document.getElementById( 'primary-navigation' );

	// Return early if the navigation doesn't exist.
	if ( ! siteNavigation ) {
		return;
	}

	const headerButtons = document.getElementById( 'header-buttons' );

	const button = document.getElementById( 'primary-menu-toggle' );

	// Return early if the button doesn't exist.
	if ( 'undefined' === typeof button || ! button ) {
		return;
	}

	const menu = siteNavigation.getElementsByTagName( 'ul' )[ 0 ];

	// Hide menu toggle button if menu is empty and return early.
	if ( 'undefined' === typeof menu || ! menu ) {
		button.style.display = 'none';
		return;
	}

	button.addEventListener( 'click', function ( e ) {
		e.preventDefault();
		siteNavigation.classList.toggle( 'hidden' );
		if ( headerButtons ) {
			headerButtons.classList.toggle( 'hidden' );
		}

		if ( button.getAttribute( 'aria-expanded' ) === 'true' ) {
			document.body.style.overflow = 'auto';
			button.setAttribute( 'aria-expanded', 'false' );
		} else {
			document.body.style.overflow = 'hidden';
			button.setAttribute( 'aria-expanded', 'true' );
		}
	} );

	document.addEventListener( 'click', function ( e ) {
		const isClickInside =
			siteNavigation.contains( e.target ) || button.contains( e.target );

		if ( ! isClickInside ) {
			siteNavigation.classList.add( 'hidden' );
			button.setAttribute( 'aria-expanded', 'false' );
			if ( headerButtons ) {
				headerButtons.classList.add( 'hidden' );
			}
			document.body.style.overflow = 'auto';
		}
	} );
} )();

( function () {
	const body = document.body;
	const main = document.querySelector( 'main' );

	if ( ! main || ! body ) return;

	const setContentWidth = () => {
		body.style.setProperty( '--page-width', main.clientWidth + 'px' );
		body.style.setProperty( '--screen-width', body.clientWidth + 'px' );
	};

	// Throttle resize events for better performance
	let resizeTimeout;
	window.addEventListener( 'resize', function () {
		clearTimeout( resizeTimeout );
		resizeTimeout = setTimeout( setContentWidth, 100 );
	} );

	setContentWidth();
} )();
